export default __webpack_public_path__ + "assets/images/4f48e9a495a9dcb2424a88080db71f22.png";